import type { EdgeDevice, NewEdgeDevice } from '@/models/EdgeDevice';
import CoreApi from '@/api/CoreApi';

export async function loadEdgeDevices(): Promise<EdgeDevice[]> {
  const response = await CoreApi.axiosClient.get('/admin/edge-devices');
  return response.data;
}

export async function createEdgeDevice(
  newDevice: NewEdgeDevice,
): Promise<void> {
  await CoreApi.axiosClient.post('/admin/edge-devices', newDevice);
}

export async function patchEdgeDevice(
  deviceToPatch: EdgeDevice,
): Promise<void> {
  await CoreApi.axiosClient.patch('/admin/edge-devices', deviceToPatch);
}

export async function deleteEdgeDevice(
  deviceToDelete: EdgeDevice,
): Promise<void> {
  await CoreApi.axiosClient.delete(
    `/admin/edge-devices/${deviceToDelete.serialNumber}`,
  );
}
